export class Module {
    id: number;
    name : string;
    link : string;
    descr: string;
    type: string;
    active: boolean;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/module.ts